import { Component, ViewChild, ElementRef, AfterViewInit, inject } from '@angular/core';
import { IncidentInsertCommand } from '../../commons/class/incident.class';
import { GatewayService } from './gateway-service';
import { AlertService } from '../../commons/components/alert/alert.service';
import { AlertComponent } from '../../commons/components/alert/alert.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../commons/services/auth.service';
import { v4 as uuidv4 } from 'uuid';
import { ModalIframeService } from '../../commons/components/modal-iframe/modal-iframe.service';
import { Documents } from '../../commons/class/archivo.inteface';
import { ElectronicDemandService } from '../demanda/electronicDemand.service';
import { ListaArchivosComponent } from '../../commons/components/downLoadFile/lista-archivos/lista-archivos.component';
import { ConfirmationDialogService } from '../../commons/components/confirm-dialog/confirm-dialog.service';
import { LoaderComponent } from '../../commons/components/loader/loader.component';
import { Router } from '@angular/router';
import { ENV_TOKEN } from '../../app-module.token';
import { FirmadorService } from '../../commons/shared/firmador.service';




@Component({
  selector: 'oaj-incidencias-itx',
  imports: [AlertComponent, ReactiveFormsModule, ListaArchivosComponent, LoaderComponent],
  templateUrl: 'incidencias.component.html',
  styleUrls: ['incidencias.component.css'],
  providers: [AlertService, AuthService, ModalIframeService, ConfirmationDialogService]

})
export class IncidenciasComponent implements AfterViewInit {
  formulario: FormGroup;
  loading = false;
  private constService: any;
  uuid = "0";
  public lstDocumentos: any[] = [];
  isLoadingFile = false;
  sMensajeLoad = "Consultando archivos...";
  showFiles = true;
  @ViewChild('txtAincidencia') textareaRef!: ElementRef<HTMLTextAreaElement>;
  bAcceptDocx = true;
  sFormatos = 'PDF';

  private gatewayService: GatewayService = inject(GatewayService);
  private alertService: AlertService = inject(AlertService);
  private fb: FormBuilder = inject(FormBuilder);
  private authService: AuthService = inject(AuthService);
  private modalIframeService: ModalIframeService = inject(ModalIframeService);
  private _service: ElectronicDemandService = inject(ElectronicDemandService);
  private modalConfirmacionService: ConfirmationDialogService = inject(ConfirmationDialogService);
  private router: Router = inject(Router);
  readonly environment = inject(ENV_TOKEN);
  private firmador = inject(FirmadorService);

  constructor() {
    this.formulario = this.fb.group({
      descripcionIncidencia: ['']
    });
    this.constService = this.environment;
  }

  ngAfterViewInit() {
      if(this.bAcceptDocx){
      this.sFormatos = 'PDF, DOCX';
    }
    else{
      this.sFormatos='PDF'
    }
    this.textareaRef.nativeElement.focus();
  }

  /**
   * Funcion para insertar una nueva incidencia, se valida que se haya capturado información en la descripción de la incidencia, si es así se hace una llamada al servicio para registrar la incidencia, si se registra correctamente se muestra un mensaje de éxito y se limpia el formulario, si ocurre un error durante el registro se muestra un mensaje de error
   * @returns 
   */
  insertaIncidencia() {
    this.loading = true;
    const requestRegistroIncidencia: IncidentInsertCommand = new IncidentInsertCommand();
    requestRegistroIncidencia.idOrganismo = this.authService.getIdOrgan();
    requestRegistroIncidencia.guidRel = this.uuid;
    const incidencia = this.formulario.get('descripcionIncidencia')?.value;

    if (!incidencia || incidencia.trim() === '') {
      this.loading = false;
      this.alertService.warn("No ha capturado información en la descripción de incidencia, favor de capturar", { autoClose: true, keepAfterRouteChange: false });
      return;
    }
    else {
      requestRegistroIncidencia.incidencia = incidencia;
    }

    this.gatewayService.InsertIncidencia(requestRegistroIncidencia).subscribe({
      next: (response: any) => {
        this.loading = false;
        if (response.succcess) {
          //  console.log(response);
          this.formulario.get('descripcionIncidencia')?.reset();
          this.alertService.success(response.message, { autoClose: true, keepAfterRouteChange: false });
          this.forceReloadFiles();
        }
        else {
          //   console.log(response)
          this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
        }
      },
      error: (error) => {
        this.loading = false;
        console.error('error al insertar la incidencia:', error.message);
        this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
      }
    });
  }

  async validSign(): Promise<void> {
    const aceptado = await this.modalConfirmacionService.confirm('Carga de archivos', '¿Requiere firmar los documentos?', 'Si', 'No');
    if (aceptado) {
      this.openWindowFirma();
    } else {
      this.cargaArchivo();
    }
  }

  cargaArchivo(): void {
    const IdPantalla = 0;
    const TipoArchivo = this.constService.TipoDoctos.Incidencias;

    if (this.uuid == "0") {
      this.uuid = uuidv4();
    }

    const urlFirma = `${this.constService.baseUrlFirma}?userName=${this.authService.getUserName()}&idUser=${this.authService.getIdUser()}&idOrganismo=${this.authService.getIdOrgan()}&IdSystem=1&IdPantalla=${IdPantalla}&IdTransaction=${this.uuid}&tipoArchivo=${TipoArchivo}&f1=0&ma=0&fo=2`;

    this.modalIframeService.open('Carga de documentos',
      urlFirma,
      'Cerrar',
      'xl').then((closed) => {
        if (closed) {
          this.GetDocumentosPantalla(this.uuid).then((resolve) => {
            this.lstDocumentos = resolve;
          });
        }
      }).catch(() => console.error('Ocurrio un error con la modal de iframe'));
  }

  async openWindowFirma(): Promise<void> {
    if (this.uuid === "0") {
      this.uuid = uuidv4();
    }

    this.isLoadingFile = true;
    try {
      const signCompletedData = await this.firmador.openWindowFirma(this.uuid, this.constService.TipoDoctos.Incidencias, this.bAcceptDocx);
      if (signCompletedData.length > 0) {
        this.lstDocumentos = signCompletedData;
      }
    } finally {
      this.isLoadingFile = false;
    }
  }

  /**
   * Funcion para obtener la lista de documentos relacionados a la incidencia, se hace una consulta al servicio para obtener los documentos dependiendo del guid de la incidencia, si se obtiene la informacion se asigna a la propiedad lstDocumentos para mostrarla en la vista, se muestra un mensaje de error si ocurre un error durante la consulta de los documentos
   * @param uuid 
   * @returns 
   */
  public GetDocumentosPantalla(uuid: string): Promise<Documents[]> {

    return new Promise((resolve) => {
      this.isLoadingFile = true;
      this._service.getDocumentosPantallaGuid(uuid)
        .subscribe((response: Documents[]) => {
          if (response?.length > 0) {
            this.isLoadingFile = false;

            resolve(response);
          }
          else {
            this.isLoadingFile = false;
            resolve([]);
          }
        }, (error: any) => {
          this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
          this.isLoadingFile = false;
          resolve([]);
        });

    });
  }

  /**
   * Funcion para eliminar un documento relacionado a la incidencia, se muestra una modal de confirmación para confirmar la eliminación del documento, si se confirma se hace una llamada al servicio para eliminar el documento, si se elimina correctamente se muestra un mensaje de éxito y se actualiza la lista de documentos, si ocurre un error durante la eliminación se muestra un mensaje de error
   * @param Documento 
   */
  EliminarDocumentosPantalla(Documento: any): void {
    this.modalConfirmacionService.confirm('Confirmación',
      'Va eliminar el documento con nombre original ' + Documento.NombreOriginal + ', ¿desea continuar?',
      'Aceptar',
      'Cancelar',
      'sm').then((confirmed) => {
        if (confirmed) {
          this._service.EliminarDocumentosPantalla(Documento.IdDocumento).subscribe({
            next: (response: any) => {
              if (response.succcess) {
                this.alertService.success("Se eliminó correctamente el documento", { autoClose: true, keepAfterRouteChange: false });
                this.GetDocumentosPantalla(this.uuid).then((resolve) => {
                  this.lstDocumentos = resolve;
                });
              }
            },
            error: (error) => {
              this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
              return;
            }
          });
        }
      }).catch(() => console.error('Ocurrio un error con la modal de confirmación'));

  }

  /**
   * Funcion para forzar la recarga del componente de lista de documentos, se destruye el componente y se vuelve a crear para actualizar la información mostrada, se resetea el uuid para generar uno nuevo en caso de que se quiera cargar un nuevo documento, se limpia la lista de documentos para evitar mostrar información antigua durante la recarga, se resetea el estado de carga en caso de que haya quedado en true por algún error durante la consulta de los documentos
   */
  forceReloadFiles(): void {
    this.showFiles = false; // Destroy the component    
    setTimeout(() => {
      this.uuid = "0" // Reset UUID to ensure a new one is generated on the next file upload
      this.lstDocumentos = []; // Clear the document list to avoid showing old data during the reload
      this.isLoadingFile = false; // Reset loading state in case it was left true
      this.showFiles = true; // Recreate the component
    }, 0); // Use setTimeout to allow Angular to process the destruction first
  }

  /**
   * Funcion para recargar la ruta actual, se navega a una ruta temporal y luego se vuelve a navegar a la ruta actual para forzar la recarga del componente, se utiliza el método navigateByUrl con skipLocationChange para evitar que se agregue la ruta temporal al historial del navegador
   */
  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

} 